import styled from 'styled-components'
import { breakpoints } from '@awazevr/design-system.utils.react'

export const StyledCarouselFloatingElements = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`

export const StyledCarouselContainer = styled.div`
  position: relative;
  z-index: 1;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    grid-row: 1 / span 3;
    grid-column: 1;
  }
`

export const StyledSingleImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 375 / 288;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    aspect-ratio: 768 / 440;
  }

  @media only screen and (min-width: ${breakpoints[1]}px) {
    aspect-ratio: 692 / 384;
  }
`

export const StyledSingleImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`

export const StyledFallbackImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 375 / 288;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    aspect-ratio: 768 / 440;
  }

  @media only screen and (min-width: ${breakpoints[1]}px) {
    aspect-ratio: 692 / 384;
  }
`
